// src/components/AdminEmployeeView.js
import React, { useCallback, useEffect, useState } from "react";
import { Tabs, Tab, Container } from "react-bootstrap";
import AnnualLeaves from "./AnnualLeaves";
import UpdateLeaves from "./UpdateLeaves";
import CompOffRequests from "./CompOffRequests";
import { io } from "socket.io-client";
import axios from "axios";
import AttendanceEntry from "./AttendanceEntry";
import UpdateAttendance from "./UpdateAttendance";
import moment from "moment";
const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5000";
// initialize socket connection
const socket = io(API_URL);
const AdminEmployeeView = () => {
  const [activeTab, setActiveTab] = useState("annual");

  // -----------------------
    // 1) Attendance Entry
    // -----------------------
    const [hangoutMessages, setHangoutMessages] = useState("");
    const [attendanceTableData, setAttendanceTableData] = useState([]);
    const [otherMessagesTableData, setOtherMessagesTableData] = useState([]);
    const [attendanceToSave, setAttendanceToSave] = useState([]);
    const [loading, setLoading] = useState(false);
  
    // -----------------------
    // 2) Update Attendance
    // -----------------------
    const [employees, setEmployees] = useState([]);
    const [selectedEmployee, setSelectedEmployee] = useState("");
    const [employeeAttendance, setEmployeeAttendance] = useState([]);
    const [selectedRecord, setSelectedRecord] = useState(null);
    const [approvedBy, setApprovedBy] = useState("");
    const [reason, setReason] = useState("");
    const [location, setLocation] = useState("");
    const [clockIn, setClockIn] = useState("");
    const [clockOut, setClockOut] = useState("");

   // For styling textareas/tables in the Entry tab
  const hangoutTextareaStyle = {
    height: "300px",
    width: "100%",
    overflowX: "scroll",
    overflowY: "scroll",
    border: "1px solid #ccc",
    padding: "8px",
    resize: "none",
    whiteSpace: "pre",
    wordWrap: "normal",
  };

  const tableContainerStyle = {
    height: "300px",
    overflowX: "scroll",
    overflowY: "scroll",
    border: "1px solid #ccc",
    whiteSpace: "nowrap",
    padding: "8px",
  };

  // -----------------------
  // Fetch employees on mount
  // -----------------------
  useEffect(() => {
    const fetchEmployees = async () => {
      try {
        const response = await axios.get(`${API_URL}/api/users`);  // updated endpoint
        setEmployees(response.data);
      } catch (error) {
        console.error("Error fetching employees:", error);
      }
    };
    fetchEmployees();
  }, []);

  // -----------------------
  // Attendance Entry Logic
  // -----------------------
  const handleFilter = useCallback(() => {
    const lines = hangoutMessages
      .split("\n")
      .map((line) => line.trim())
      .filter((line) => line !== "");

    if (lines.length === 0) {
      setAttendanceTableData([]);
      setOtherMessagesTableData([]);
      setAttendanceToSave([]);
      return;
    }

    const formats = [
      "D MMM, YYYY",
      "MMM D,YYYY",
      "D MMM YYYY",
      "MMM D YYYY",
      "MMMM D, YYYY",
      "D MMMM, YYYY",
      "YYYY-MM-DD",
    ];
    const rawDate = lines[0].trim();
    const mDate = moment(rawDate, formats, true);
    const commonDate = mDate.isValid() ? mDate.format("YYYY-MM-DD") : rawDate;

    const attendanceRecords = [];
    const otherMessagesData = [];

    let i = 1;
    while (i < lines.length) {
      if (
        i < lines.length - 1 &&
        (lines[i + 1].startsWith("CI") || lines[i + 1].startsWith("CO"))
      ) {
        const headerLine = lines[i];
        const detailLine = lines[i + 1];
        i += 2;

        const headerParts = headerLine.split(",");
        const empName = headerParts[0].trim();
        let timeStr = "";
        if (headerParts.length > 1) {
          const timeInfo = headerParts[1].trim().replace("?", "");
          const timeParts = timeInfo.split(" ");
          timeStr = timeParts.length > 1 ? timeParts[1] : timeInfo;
        }

        const dateTime = `${commonDate} ${timeStr}`;
        const detailParts = detailLine.split(" ").filter((p) => p !== "");
        const recordType = detailParts[0] || "";
        const loc = detailParts[1] || "";

        if (recordType === "CI") {
          attendanceRecords.push({
            empName,
            inTime: dateTime,
            outTime: "",
            location: loc,
            date: commonDate,
          });
        } else if (recordType === "CO") {
          let updated = false;
          for (let j = attendanceRecords.length - 1; j >= 0; j--) {
            if (
              attendanceRecords[j].empName === empName &&
              attendanceRecords[j].date === commonDate &&
              attendanceRecords[j].inTime &&
              !attendanceRecords[j].outTime
            ) {
              attendanceRecords[j].outTime = dateTime;
              attendanceRecords[j].location = loc;
              updated = true;
              break;
            }
          }
          if (!updated) {
            attendanceRecords.push({
              empName,
              inTime: "",
              outTime: dateTime,
              location: loc,
              date: commonDate,
            });
          }
        }
      } else {
        if (
          i < lines.length - 1 &&
          lines[i].includes(",") &&
          !lines[i + 1].startsWith("CI") &&
          !lines[i + 1].startsWith("CO")
        ) {
          const senderInfoParts = lines[i].split(",");
          const senderName = senderInfoParts[0].trim();
          const messageTime =
            senderInfoParts.length > 1
              ? senderInfoParts[1].trim().replace("?", "")
              : "";
          const message = lines[i + 1];
          if (message.includes("C")) {
            otherMessagesData.push({
              senderName,
              message,
              messageTime,
              messageDate: commonDate,
            });
          }
          i += 2;
        } else {
          let senderName = "";
          let messageTime = "";
          if (lines[i].includes(",")) {
            const parts = lines[i].split(",");
            senderName = parts[0].trim();
            messageTime = parts[1] ? parts[1].trim().replace("?", "") : "";
          }
          const message = lines[i];
          if (message.includes("C")) {
            otherMessagesData.push({
              senderName,
              message,
              messageTime,
              messageDate: commonDate,
            });
          }
          i++;
        }
      }
    }

    setAttendanceTableData(attendanceRecords);
    setOtherMessagesTableData(otherMessagesData);
    setAttendanceToSave(attendanceRecords);

    socket.emit("attendanceFiltered", { attendanceRecords });
  }, [hangoutMessages]);

  const handleSave = async () => {
    if (attendanceToSave.length === 0) {
      alert("No attendance records to save. Please filter your data first.");
      return;
    }
    setLoading(true);
    try {
      const response = await axios.post(`${API_URL}/api/attendance`, {
        attendanceRecords: attendanceToSave,
      });
      alert(response.data.message);
      socket.emit("attendanceSaved", { attendanceRecords: attendanceToSave });
    } catch (error) {
      console.error("Error saving records:", error);
      alert("Failed to save attendance records.");
    }
    setLoading(false);
  };

  // 2) Update Attendance Logic
  useEffect(() => {
    if (!selectedEmployee) {
      setEmployeeAttendance([]);
      return;
    }
    fetchEmployeeAttendance(selectedEmployee);
  }, [selectedEmployee]);

  const fetchEmployeeAttendance = async (empName) => {
    try {
      const response = await axios.get(
        `${API_URL}/api/attendance?empName=${encodeURIComponent(empName)}`
      );
      setEmployeeAttendance(response.data);
    } catch (error) {
      console.error("Error fetching employee attendance:", error);
    }
  };

  const handleRowClick = (record) => {
    setSelectedRecord(record);
    setApprovedBy(record.approved_by || "");
    setReason(record.reason || "");
    setLocation(record.location || "");
    setClockIn(record.in_time || "");
    setClockOut(record.out_time || "");
  };

  const handleUpdate = async () => {
    if (!selectedRecord) {
      alert("No record selected for update!");
      return;
    }
    try {
      const requestBody = {
        inTime: clockIn,
        outTime: clockOut,
        location,
        date: selectedRecord.date,
        approved_by: approvedBy,
        reason,
      };

      await axios.put(
        `${API_URL}/api/attendance/${selectedRecord.id}`,
        requestBody
      );
      alert("Attendance updated successfully!");
      socket.emit("attendanceUpdated", { recordId: selectedRecord.id });
      fetchEmployeeAttendance(selectedEmployee);
    } catch (error) {
      console.error("Error updating attendance:", error);
      alert("Failed to update attendance record.");
    }
  };

  // Socket.IO listeners
  useEffect(() => {
    socket.on("attendanceSaved", ({ attendanceRecords }) => {
      alert("Attendance was just saved by another user.");
      handleFilter();
    });

    socket.on("attendanceUpdated", ({ recordId }) => {
      if (selectedEmployee) {
        fetchEmployeeAttendance(selectedEmployee);
      }
    });

    return () => {
      socket.off("attendanceSaved");
      socket.off("attendanceUpdated");
      socket.disconnect();
    };
  }, [selectedEmployee, handleFilter]);

  return (
    <Container fluid className="px-2 px-md-4 py-3" style={{ minHeight: "100vh", height: "100%" }}>
      <div className="underline-tabs">
      <Tabs
        id="admin-leave-tabs"
        activeKey={activeTab}
        onSelect={(k) => setActiveTab(k)}
        className="flex-nowrap"
      >
         {/* 1) Attendance Entry Tab */}
        <Tab eventKey="entry" title="Attendance Entry">
          <AttendanceEntry
            hangoutMessages={hangoutMessages}
            setHangoutMessages={setHangoutMessages}
            attendanceTableData={attendanceTableData}
            otherMessagesTableData={otherMessagesTableData}
            attendanceToSave={attendanceToSave}
            loading={loading}
            handleFilter={handleFilter}
            handleSave={handleSave}
            hangoutTextareaStyle={hangoutTextareaStyle}
            tableContainerStyle={tableContainerStyle}
          />
        </Tab>

        {/* 2) Update Attendance Tab */}
        <Tab eventKey="updateAttendance" title="Update Attendance">
          <UpdateAttendance
            employees={employees}
            selectedEmployee={selectedEmployee}
            setSelectedEmployee={setSelectedEmployee}
            employeeAttendance={employeeAttendance}
            handleRowClick={handleRowClick}
            handleUpdate={handleUpdate}
            approvedBy={approvedBy}
            setApprovedBy={setApprovedBy}
            reason={reason}
            setReason={setReason}
            location={location}
            setLocation={setLocation}
            clockIn={clockIn}
            setClockIn={setClockIn}
            clockOut={clockOut}
            setClockOut={setClockOut}
          />
        </Tab>
        <Tab eventKey="annual" title="Leaves / Holidays">
          <AnnualLeaves />
        </Tab>
        <Tab eventKey="updateLeaves" title="Update Leaves">
          <UpdateLeaves />
        </Tab>
        <Tab eventKey="compoff" title="Comp Off Requests">
          <CompOffRequests />
        </Tab>
        
      </Tabs>
      </div>
    </Container>
  );
};

export default AdminEmployeeView;
